var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGnunSymbol = function SvgGnunSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD267",
    d: "M6.793 7.205H3.601A3.6 3.6 0 0 1 1.054 6.15l6.794 6.793a3.6 3.6 0 0 1-1.055-2.547z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M3.603 0a3.603 3.603 0 1 0 0 7.205h3.192v3.192a3.6 3.6 0 0 0 1.055 2.547A3.602 3.602 0 0 0 14 10.397V0z"
  })));
};
export default SvgGnunSymbol;